import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { GET_ORGANISATION } from '../../../../action/apiPath';
import { CallWithAuth } from '../../../../action/apiActions';
import VerticalLine from '../../../../assets/images/vertical-line.svg';
import style from '../../../../assets/styles/organisationManagement.module.css';
import { ChangeOrganisation } from '../../../../redux/action';
import { useDispatch } from 'react-redux';
import AuthLayout from '../../../../layout/AuthLayout';
import RightPanelTopMenu from '../../common/RightPanelTopMenu';
import { useNavigate, useParams } from 'react-router-dom';
import { UserScreenChange } from '../../../../redux/action';

const OrganisationDetails = () => {
  const { orgId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [organisationInfo, setOrganisationInfo] = useState(null);

  const getOrganisationInfo = async () => {
    try {
      const response = await CallWithAuth('GET', GET_ORGANISATION + orgId + '/get-org-details/');
      if (response.res.status === 200 && response.res.data) {
        setOrganisationInfo(response.res.data.data);
      }
    } catch (error) {
      console.error('Error fetching organization details:', error);
    }
  };

  useEffect(() => {
    getOrganisationInfo();
  }, [orgId]);

  const handleEditOrg = () => {
    dispatch(UserScreenChange(1));
    navigate(`/organization-management/edit/${organisationInfo?.id}`);
  };

  return (
    <AuthLayout>
      <RightPanelTopMenu setQuestionBankId={null} title={'Organization Management'} />
      <div>
        <div className={style.orgTop_section}>
          <button
            className={style.buttonStyle}
            onClick={() => {
              dispatch(ChangeOrganisation(0));
              navigate(`/organization-management`);
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.5488 19.422L9.02883 12.902C8.25883 12.132 8.25883 10.872 9.02883 10.102L15.5488 3.58203"
                stroke="#212529"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={style.backButton}>Back</span>
          </button>

          <div className={` ${style.table_content_report}  ${style.organisation_profileTableHeight}`}>
            <div className={`${style.profile_detail_div} ${style.profile_headerdetail}`}>
              <div className={style.organisationInfo}>
                <span title={organisationInfo?.name} style={{ fontSize: '16px', fontWeight: '600' }}>
                  {organisationInfo?.name.length > 100
                    ? organisationInfo?.name.substr(0, 100) + '...'
                    : organisationInfo?.name}
                </span>
                <span
                  className={organisationInfo?.is_active === true ? `${style.statusActive}` : `${style.statusInactive}`}
                >
                  {organisationInfo?.is_active === true ? 'Active' : 'Inactive'}
                </span>
              </div>
              <button
                className={style.editButtonStyle}
                onClick={() => {
                  dispatch(ChangeOrganisation(3));
                  handleEditOrg();
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 22H21" stroke="#00ABFB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path
                    d="M13.2603 3.59924L5.05034 12.2892C4.74034 12.6192 4.44034 13.2692 4.38034 13.7192L4.01034 16.9592C3.88034 18.1292 4.72034 18.9292 5.88034 18.7292L9.10034 18.1792C9.55034 18.0992 10.1803 17.7692 10.4903 17.4292L18.7003 8.73924C20.1203 7.23924 20.7603 5.52924 18.5503 3.43924C16.3503 1.36924 14.6803 2.09924 13.2603 3.59924Z"
                    stroke="#00ABFB"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.8896 5.04883C12.3196 7.80883 14.5596 9.91883 17.3396 10.1988"
                    stroke="#00ABFB"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className={style.editButton}> &nbsp; Edit </span>
              </button>
            </div>

            <div className={`${style.orgProfile_detail_info}`}>
              <div className={`${style.orgAdmin}`}>
                <label className={`${style.orgLabel}`}> Organization Admin </label>
                <div className={style.OrganizationAdminWrap}>
                  {organisationInfo?.organization_admin?.map((admin, index) => (
                    <span key={index} className={style.OrganizationAdminName}>
                      {admin}
                    </span>
                  ))}
                </div>
              </div>
              <img src={VerticalLine} className={style.vertical_line} alt="Vertical Line" />
              <div>
                <div className={style.orgLabel}>No. of Users:</div>
                <div className={style.orgUserCount}>{organisationInfo?.no_of_users || 0}</div>
              </div>
              <img src={VerticalLine} className={style.vertical_line} alt="Vertical Line" />
              <div>
                <div className={style.orgLabel}>No. of Questions:</div>
                <div className={style.orgUserQuestionCount}>{organisationInfo?.no_of_questions || 0}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

OrganisationDetails.propTypes = {
  id: PropTypes.any,
  setScreen: PropTypes.any,
};

export default OrganisationDetails;
